import React from "react";
import styles from "./TableHeadItem.module.scss";

type TableHeadItemProps = {
  item: string;
};

export const TableHeadItem = ({ item }: TableHeadItemProps) => {
  return <td className={styles.headerItem}>{item}</td>;
};
